import React, { Component } from 'react';
import Currency from './currency'

export default class ExpoPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pgLimit: 5,
            pageNo: 1,
            totalPage: 1
        };
    }
    componentDidMount() {
    }
    render() {
        return (
            <>
                <div id="marketbetspopup" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                    <div className="modal-dialog" style={{ maxWidth: "300px !important" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title mt-0" id="myModalLabel">Exposure</h5><button onClick={() => { this.props.hidePopup() }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                {!!this.props.lineName && <div className="model-fancy-line-name">{this.props.lineName}</div>}
                                <div className="table-responsive" style={{ maxHeight: "300px" }}>
                                    <table id="basic-btn" className="table table-bordered font-12 table-sm mb-0">
                                        <tbody>
                                            {Object.keys(this.props.lineExpo).map((i) => {
                                                let expo = this.props.lineExpo[i].expo
                                                return <tr className={expo < 0 ? "lay-bg" : "back-bg"}>
                                                    <td>{i}</td>
                                                    <td style={{ width: "50%" }}><Currency classPropName={"float-right  font-weight-bold"} amount={expo} showColor={true} /></td>
                                                </tr>
                                            })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" onClick={() => { this.props.hidePopup() }} className="btn btn-outline-danger waves-effect mx-auto" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show" onClick={() => { this.props.hidePopup() }}></div>
                </div>
            </>
        )
    }
}
